import React, { useState, useEffect } from 'react';

import '../../App.css'
import editIcon from '../../img/Edit-Icon.svg';

const HeadGallery = ({ currentThumbnail, onThumbnailSelect, model, assets }) => {

    const tabs = ['all', 'primaryImages', 'secondaryImages'];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedThumbnail, setSelectedThumbnail] = useState(currentThumbnail); // State for selected thumbnail in the modal
    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const selectTab = (num) => {
        setSelectedTab(tabs[num]);
    }

    const toggleModal = () => {
        if (!isModalOpen) {
            setSelectedThumbnail(currentThumbnail); // Reset to latest thumbnail on open
        }
        setIsModalOpen((prev) => !prev);
    };

    const selectThumbnail = (imageSrc) => {
        setSelectedThumbnail(imageSrc); // Update the selected thumbnail in the modal, but do not change the current thumbnail yet
    };

    const applyThumbnail = () => {
        onThumbnailSelect(selectedThumbnail); // Only update current thumbnail when apply is pressed
        toggleModal();
    };

    const cancel = () => {
        setSelectedThumbnail(currentThumbnail); // Reset the selected thumbnail in modal to the current thumbnail on cancel
        toggleModal();
    };

    const renderTab = () => {
        const imagesToGet = [];
        const list = [];

        switch (selectedTab) {
            case tabs[1]: imagesToGet.push(tabs[1]);
                break;
            case tabs[2]: imagesToGet.push(tabs[2]);
                break;
            default: imagesToGet.push(tabs[1], tabs[2]);
        };

        {
            assets && imagesToGet.map((imageCategory, i) => (
                assets[imageCategory]?.map((image, index) => {
                    list.push(
                        <img
                            key={`Thumbnail ${i} + ${index + 1}`}
                            src={image.file}
                            alt={`Thumbnail ${index + 1}`}
                            onClick={() => selectThumbnail(image.file)}
                            className={'media-image clickable' + (image.file === selectedThumbnail ? ' selected' : '')}
                        />
                    )
                }
                )
            ));
        }

        return list;
    }

    {/* this is where the gallery next to the thumbnail is picked */ }
    const renderGallery = () => {
        var galleryPolaroids = '';
        var galleryPictures = '';
        const list = [];
        const secondaryImages = assets.secondaryImages || [];
        const primaryImages = assets.primaryImages || [];

        if (primaryImages.length >= 1) {
            galleryPolaroids = (
                <div>
                    <h4>
                        Polaroid
                    </h4>
                    <div className="model-polaroids">
                        <img
                            key={'polaroid'}
                            src={primaryImages[0].file}
                            alt={`Polaroid`}
                            className="polaroid-image"
                        />
                    </div>
                </div>);
        }

        if (secondaryImages.length >= 1) {
            for (let i = 0; i < secondaryImages.length && i < 5; i++) {
                list.push(
                    <img
                        key={'picture' + i}
                        src={secondaryImages[i].file}
                        alt={`Picture ${i + 1}`}
                        className="polaroid-image"
                    />);
            }

            galleryPictures = (
                <div>
                    <h4>
                        Pictures
                    </h4>
                    <div className="model-polaroids">
                        {list}
                    </div>
                </div>
            )
        }

        return (
            <div className='gallery'>
                {galleryPictures}
                {galleryPolaroids}
            </div>
        )
    }

    return (
        <div>
            <div className="thumbnail-container">
                {/* Display currentThumbnail, which is not affected by the modal's selection until Apply is pressed */}
                <div className="model-thumbnail" onClick={toggleModal}>
                    <img src={currentThumbnail} alt="Current Thumbnail" />
                    {/* Edit icon overlay */}
                    <div className="edit-icon">
                        <img src={editIcon} alt="Edit" className="edit-icon-img" />
                    </div>
                </div>
                {renderGallery()}
            </div>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div>
                            <button className='button' onClick={() => selectTab(0)}>
                                All Images
                            </button>
                            <button className='button' onClick={() => selectTab(1)}>
                                Polaroids
                            </button>
                            <button className='button' onClick={() => selectTab(2)}>
                                Pictures
                            </button>
                        </div>
                        <div className="thumbnail-options">
                            {renderTab()}
                        </div>
                        <div>
                            <button className='button' onClick={cancel}>
                                Cancel
                            </button>
                            <button className='button' onClick={applyThumbnail}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HeadGallery;
